// import "./style.less";
import "@webcomponents/webcomponentsjs";
import "@webcomponents/webcomponentsjs/custom-elements-es5-adapter.js";

import "oc-ui/errorHandling";
import "oc-ui/dialogs/DialogsBootstrap3";

import "oc-commons/extensions/StringExtensions";
import "oc-threejs/extensions/three.convenience.js";
import Commons from "oc-commons/Commons";
import Doms from "oc-commons/Doms";

import MaterialLib from "./model/MaterialLib.js";
import SettingsMixin from "./model/SettingsMixin";
import { v3 } from "oc-threejs/short3";

import AbstractApp from "oc-app/AbstractApp";
import UniversalLoader from "oc-threejs/loader/UniversalLoader";
import Stage from "oc-threejs/Stage";

import Model from "./model/Model";
import UIHandler from "./ui/Handler";

import TWEEN from "tween";
import InteractionHandler from "./interaction/InteractionHandler";
import "three/examples/js/postprocessing/EffectComposer.js";
import "three/examples/js/postprocessing/RenderPass.js";
import "three/examples/js/postprocessing/ShaderPass.js";
import "three/examples/js/postprocessing/SAOPass.js";
// import "three/examples/js/postprocessing/SSAOPass.js";
// import "three/examples/js/postprocessing/SSAARenderPass.js";
// import "three/examples/js/postprocessing/TAARenderPass.js";
// import "three/examples/js/postprocessing/MaskPass.js";
import "three/examples/js/shaders/CopyShader.js";
import "three/examples/js/shaders/SAOShader.js";
import "three/examples/js/shaders/DepthLimitedBlurShader.js";
import "three/examples/js/shaders/UnpackDepthRGBAShader.js";

import Helper from "./model/Helper";
import "three/examples/js/libs/stats.min.js";
import dat from "three/examples/js/libs/dat.gui.min.js";

import { saveAs } from "browser-filesaver";
import Dialogs from "oc-ui/dialogs/Dialogs";

import boundingBoxes from "./boundingBoxes.json";
import VisibleSwitchRenderPass from "./model/VisibleSwitchRenderPass";
import Asserts from "oc-commons/Asserts";
import Schubladenbox from "./arrangement/Schubladenbox";
import Arrangement from "./arrangement/Arrangement";
import UrlFluid from "oc-commons/UrlFluid";
import Urls from "oc-commons/Urls";
import JacoApp from "../../../../../Wirtschaftswunder/holodeck/modules/oc-jaco3d/JacoApp.js";
// import Wkfg2BackendApi from "oc-app/Wkfg2BackendApi";
import SceneWkfg2Importer from "oc-app/scene/SceneWkfg2Importer";
import { Vector2 } from "three/build/three";
import { ModellSettingsMixin } from "./model/ModellSettingsMixin.js";
import RichMetadata from "./richMetadata.js";
import uiActions from "./ui/uiActions.js";

window.USE_SAFE_PROMISE = false;

/**
 */
export default class Schrankplaner extends AbstractApp {
    model: Model;
    ui: Object;
    interactionHandler: InteractionHandler;
    productList: [];
    contentBaseUrl: string;
    msPerFrame = 0;
    version: string;
    idCounter = 0;
    toInspiration = false;

    constructor(container, data) {
        super("Schrankplaner", container, data);
        this.undoHandler.debounceTimer = 500;
        $.ajaxSetup({
            headers: {
                "X-CSRF-Token": this.settings.xcsrfToken,
            },
        });
        if (this.settings.localDevelopmentMode) {
            // frisst einiges an Performance!
            THREE.DebugFishyVectors();
        }

        this.version = "<<<<<---RELEASE_NUMBER--->>>>>";
        this.metamodel = data.metamodel;
        this.metadata = data.metadata;
        this.configuration = data.Konfiguration;
        console.log("APP.configuration", APP.configuration);

        this.contentBaseUrl = SETTINGS.wkfgContentBaseUrl;

        this.wkfgBackendApi = this.createWkfgBackendApi();
        this.typeConverter = this.createWkfgTypeConverter();
        this.initMetadata();
        this.initStage();
        this.sceneImporter.setEnvironment("Default");
        STAGE.scene.background = null;
        this.interactionHandler = new InteractionHandler(container);
        this.arrangement = new Arrangement();
        this.model = new Model();
        STAGE.add(this.model);
        this.model.loadConfiguration();
        this.initUI();
        const changedProductsHinweistexte = APP.arrangement.getChangedProductsHinweistexte();
        if (changedProductsHinweistexte.length > 0) {
            APP.arrangement.setHinweisTextAndTitle("dialogImportHeader", changedProductsHinweistexte[0]);
            changedProductsHinweistexte.forEach((changedProduct, index) => {
                if (index > 0) {
                    APP.arrangement.setHinweisText(changedProduct);
                }
            });
            this.model.maybeShowHinweistexteDialog();
        }

        this.interactionHandler.setSceneDroppable();
        this.setInitialCamera();
        STAGE.startRenderLoop();
        this.maybeLoadFromLocalStorage();
        this.measureFrameRate();
        this.checkHaendler();
        // this.richMetadata = new RichMetadata();
    }

    setStageFromConfiguration(configurationJson = null) {
        _.merge(this.configuration, configurationJson);
        this.arrangement.fromJSON(configurationJson);
        this.arrangement.compile();
    }

    checkHaendler() {
        const error = (heading, text) => {
            APP.uiHandler.dialog({
                title: heading, //'Speichern ist fehlgeschlagen!',
                text: text, //'Wir konnten Ihren Schrank nicht speichern.',
                buttons: [
                    {
                        style: "primary",
                        label: I18N("Haendler-Login"),
                        onClick: () => {
                            const redirectURL = APP.settings.haendlerlogin_error_login_url;
                            window.location.href = redirectURL;
                        },
                    },
                    {
                        style: "primary",
                        label: I18N("Haendler-Uebersicht"),
                        onClick: () => {
                            const redirectURL = APP.settings.haendlerlogin_error_redirect_url;
                            window.location.href = redirectURL;
                        },
                    },
                ],
            });
        };

        if (this.settings.haendlerlogin_aktiv) {
            const urlParams = new URLSearchParams(window.location.search);
            const haendlerId = urlParams.get("haendler");
      
            if (APP.settings.haendler) {
              this.haendler = APP.settings.haendler;
              this.haendlerRabatt = true;
            } else if (haendlerId) {
              const haendler = _.find(APP.metadata.Haendler, (value, key) => {
                return value.id == parseInt(haendlerId);
              });
              if (!haendler) {
                error(I18N("noHaendler"), I18N("incorrect-Haendler"));
              }
              this.haendler = haendler;
              this.haendlerRabatt = false;
            } else {
              error(I18N("noHaendler"), I18N("noHaendlerText"));
            }
        }
    }

    setPriceCallbacks() {
        APP.on("priceUpdated", (preis) => {
            this.updateUIForced();
        });
    }

    priceStarts = 0;
    latestPriceData;

    debouncedUpdatePrices = _.debounce(() => {
        this.priceStarts++;
        this.wkfgBackendApi.updatePrices(this.latestPriceData).then((result) => {
            this.priceStarts--;
            if (this.priceStarts == 0) {
                APP.updateUIForced();
            }
        });
    }, 1000);

    updatePrices = (data) => {
        APP.trigger("priceUpdate");
        this.latestPriceData = data;
        this.debouncedUpdatePrices();
    };

    measureFrameRate() {
        this.msPerFrame = 1;
        _.delay(() => {
            UniversalLoader.delayUntilEverythingLoaded(() => {
                _.delay(() => {
                    const start = STAGE.HEARTBEAT;
                    const cleanUp = [];
                    let measureT0;
                    const frameStart = 3;
                    const frameEnd = 8;
                    STAGE.on(
                        "beforeRenderScene",
                        () => {
                            if (STAGE.HEARTBEAT - start === frameStart) {
                                measureT0 = performance.now();
                            }
                            if (STAGE.HEARTBEAT - start === frameEnd) {
                                this.msPerFrame = (performance.now() - measureT0) / (frameEnd - frameStart);
                                const fps = (1000 / this.msPerFrame).toFixed(1);
                                console.log("FPS", fps);
                                STAGE.renderLooping = false;
                                cleanUp.forEach((x) => x());
                            }
                        },
                        cleanUp
                    );
                    STAGE.renderLooping = true;
                    STAGE.dirty();
                }, 100);
            });
        }, 100);
    }

    initMetadata() {
        this.productList = this.metadata.artikel;
        this.allArticles = this.metadata.artikel_ungefiltert;
        this.productList.filter((x) => x.type === "Material").forEach((x) => (x.TextureUrl = APP.contentBaseUrl + "Material/" + x.TextureUrl));
    }

    mergeSettings(data) {
        const defaultConfiguration = data.Konfiguration.Json;
        const globalSettings = data.settings;
        const metadata = data.metadata;
        const modellWerte = metadata["Modellwerte"];
        Object.keys(modellWerte).forEach((key) => {
            modellWerte[key] = _.merge(new SettingsMixin(), modellWerte[key]);
        });
        const modelle = _.merge(new ModellSettingsMixin(), modellWerte);
        // const defaultModellSettings = modelle.get()
        // Stage and localDev Settings
        const localJSSettings = this.localJSSettings(defaultConfiguration, modelle, globalSettings);
        const localDevSettings = this.localDevSettings(defaultConfiguration, modelle, globalSettings);

        this.settings = _.merge(new SettingsMixin(), globalSettings, localJSSettings, localDevSettings, window.SETTINGS);
        this.options = modelle;

        if (metadata.EnvMap) {
            metadata.EnvMap = _.map(metadata.EnvMap, (value, key) => {
                return {
                    ...value,
                    name: key,
                };
            });
        }

        if (metadata.Environment) {
            metadata.Environment = _.map(metadata.Environment, (value, key) => {
                return {
                    ...value,
                    name: key,
                };
            });
        }

        if (metadata.MaterialPbr) {
            metadata.MaterialPbr = _.map(metadata.MaterialPbr, (value, key) => {
                return {
                    ...value,
                    name: key,
                };
            });
        }

        if (metadata.Raum) {
            metadata.Raum = _.map(metadata.Raum, (value, key) => {
                return {
                    ...value,
                    name: key,
                };
            });
        }
    }

    localJSSettings(defaultConfiguration, modelle, globalSettings) {
        return {
            raum: true,
            textureAtWallAndFloor: false,
            undo: {
                enabled: true,
                max: 20,
            },
            stage: {
                useAmbientOcclusion: false /* settings.getBool('use_ambient_occlusion') // Geht nicht mit aktueller Three Version*/,
                showFramesPerSecondInfo: false,
                // unten zeigen wir einen eigenen an
                showBoundingBoxRuler: false,
                showDebugNotANumberInSceneError: false,
                showDebugObjects: false,
                camera: {
                    near: 1,
                    far: 2000,
                    distance: {
                        min: 50,
                        max: 1000,
                    },
                },
                shadows: {
                    enabled: false && modelle.getBool(defaultConfiguration.Modell.Name, "schatten"),
                },
                /* renderer: {
                            antialias: true,
                            clearColor: {
                                color: 0xffffff
                            },
                        }, */
                renderer: {
                    //Set true to export transparent png
                    antialias: true,
                    alpha: true,
                    clearColor: {
                        color: 0xffffff,
                    },
                    sortObjects: false,
                },
                ruler: {
                    scale: 10,
                    fixed: 0,
                    unit: "mm",
                },
                dragDrop: {
                    radiusSnapEnd: 6,
                    radiusSnapStart: 3,
                },
            },
            params: {
                edit: globalSettings.edit == "true",
                admin: globalSettings.admin == "true",
            },
        };
    }

    localDevSettings(defaultConfiguration, modelle, globalSettings, mockProduction = false) {
        const localDevelopmentMode = location.hostname === "localhost" || location.hostname === "0.0.0.0";
        return localDevelopmentMode && !mockProduction
            ? {
                  localDevelopmentMode,
                  stage: {
                      camera: {
                          far: 5000,
                      },
                  },
              }
            : {
                  localDevelopmentMode,
                  stage: {
                      camera: {
                          near: 1,
                          far: 2000,
                          distance: {
                              min: 50,
                              max: 1000,
                          },
                          // TODO: Kameraposition im Raum mit multiSchrank nicht fertig
                          //   polarAngle: {
                          //       locked: modelle.getBool(defaultConfiguration.Modell.Name, "kamera_vertikal_fixiert"),
                          //       min: modelle.getMinValue(defaultConfiguration.Modell.Name, "kamera_vertikal_fixiert"),
                          //       max: modelle.getMaxValue(defaultConfiguration.Modell.Name, "kamera_vertikal_fixiert"),
                          //   },
                          //   azimuthAngle: {
                          //       min: modelle.getMinValue(defaultConfiguration.Modell.Name, "kamera_rl"),
                          //       max: modelle.getMaxValue(defaultConfiguration.Modell.Name, "kamera_rl"),
                          //   },
                          //   distance: {
                          //       min: modelle.getMinValue(defaultConfiguration.Modell.Name, "kamera_distanz"),
                          //       max: modelle.getMaxValue(defaultConfiguration.Modell.Name, "kamera_distanz"),
                          //   },
                      },
                      orbitControl: {
                          enablePan: true,
                      },
                      lightSettingsName: globalSettings.light_settings_name ? globalSettings.getValue("light_settings_name") : "default",
                  },
              };
    }

    initStage() {
        UniversalLoader.setMaterialFactory(new MaterialLib(this.contentBaseUrl + "/textures/room01/"));
        this.sceneImporter = new (class extends SceneWkfg2Importer {
            createLights(settingName = null) {
                const lights = super.createLights(settingName);
                return lights;
            }

            // make this working after update for physically correct lighting
            _copyProps(instance, parsed, acceptProp = (key) => true) {
                _.keys(instance).forEach((prop) => {
                    if (acceptProp(prop)) {
                        let value = parsed[prop];
                        if (value != null && instance[prop] != value) {
                            if (instance[prop]?.copy) {
                                const split = value.split(",");
                                const v2 = new Vector2(split[0], split[1]);
                                instance[prop].copy(v2);
                            } else {
                                instance[prop] = value;
                            }
                        }
                    }
                });
            }
        })(this.settings.wkfgContentBaseUrl);

        new (class extends Stage {
            constructor(settings) {
                super(settings);
                this.createLights();
            }

            createOrbitControl() {
                const controls = super.createOrbitControl();
                const camera = this.camera;
                const positionRaycaster = new THREE.Raycaster();
                const targetRayacaster = new THREE.Raycaster();
                let posdir = new THREE.Vector3();
                let targetdir = new THREE.Vector3(-1000, -1000, -1000);
                let positionIntersects = [];
                let targetIntersects = [];
                const lastPosition = new THREE.Vector3();
                const lastQuaternion = new THREE.Quaternion();
                const lastTarget = new THREE.Vector3();
                controls.addEventListener("change", function () {
                    if (APP.arrangement?.raum) {
                        posdir.subVectors(camera.position, controls.target).normalize();
                        positionRaycaster.set(controls.target, posdir);
                        targetRayacaster.set(controls.target, targetdir);

                        positionIntersects = positionRaycaster.intersectObject(APP.arrangement?.raum.object3d, true);
                        targetIntersects = targetRayacaster.intersectObject(APP.arrangement?.raum.object3d, true);
                        if (positionIntersects.length > 0) {
                            if (positionIntersects[0].distance - controls.target.distanceTo(camera.position) < 25) {
                                camera.position.copy(lastPosition);
                                camera.quaternion.copy(lastQuaternion);
                            } else {
                                lastPosition.copy(controls.object.position);
                                lastQuaternion.copy(controls.object.quaternion);
                            }
                        }
                        if (targetIntersects.length && targetdir.dot(targetIntersects[0].face.normal) > 0 && targetIntersects[0].distance > 5) {
                            lastTarget.copy(controls.target);
                        } else {
                            controls.target.copy(lastTarget);
                        }
                    }
                });
                return controls;
            }

            _setRenderSize(width, height) {
                // devicePixelRatio>1 führt zu Absturz auf IPads ... !?
                const devicePixelRatio = 1; //window.devicePixelRatio || 1;
                width *= devicePixelRatio;
                height *= devicePixelRatio;
                this.renderer.setSize(width, height);
                if (this.composer) {
                    this.composer.setSize(width * 2, height * 2);
                }
                $(this.renderer.domElement).css({ width: width / devicePixelRatio, height: height / devicePixelRatio });
            }

            composerHook() {
                if (!STAGE.settings.useAmbientOcclusion) {
                    return;
                }
                STAGE.useComposer = true;

                this.composer = new THREE.EffectComposer(this.renderer);

                // this.taaRenderPass = new THREE.TAARenderPass( this.scene, this.camera );
                // this.taaRenderPass.unbiased = false;
                // this.composer.addPass( this.taaRenderPass );

                this.renderPass = new THREE.RenderPass(this.scene, this.camera);
                // this.renderPass.enabled = false;

                const visibleSwitchPass = new VisibleSwitchRenderPass((x) => x.hideForSAOPASS);

                this.composer.addPass(this.renderPass);

                this.saoPass = new THREE.SAOPass(this.scene, this.camera, false, true);
                this.saoPass.renderToScreen = true;
                this.composer.addPass(visibleSwitchPass);
                this.composer.addPass(this.saoPass);
                this.composer.addPass(visibleSwitchPass);

                _.merge(STAGE.saoPass.params, {
                    saoBias: -0.68,
                    saoIntensity: 0.0005,
                    saoScale: 6,
                    saoKernelRadius: 39,
                    saoMinResolution: 0,
                    saoBlur: true,
                    saoBlurRadius: 6,
                    saoBlurStdDev: 2,
                    saoBlurDepthCutoff: 0.002,
                });

                // this.taaRenderPass.datTaaParams = {
                //     TAAEnabled: true,
                //     TAASampleLevel: 2,
                //     update() {
                //         STAGE.taaRenderPass.enabled = this.TAAEnabled;
                //         STAGE.renderPass.enabled = !this.TAAEnabled;
                //         STAGE.taaRenderPass.sampleLevel = this.TAASampleLevel;
                //     },
                // };
                // this.taaRenderPass.datTaaParams.update();
            }

            _render() {
                if (this.composer && STAGE.useComposer) {
                    this.composer.render();
                } else {
                    super._render();
                }
            }
        })(this.settings.stage);

        if (STAGE.settings.showDebugObjects) {
            STAGE.addAxisHelper(100);
        }
        if (STAGE.settings.showGround) {
            STAGE.addGroundScalePaper();
        }

        this.switchExpensiveRenderModeOffDuringMouseActions();
    }

    getStageAsConfiguration() {
        return APP.arrangement.toJSON();
    }

    switchExpensiveRenderModeOffDuringMouseActions() {
        // beim Unterschreiten dieser FPS Zahl wird das Rendering während Kamera- und Drag-Aktionen vereinfacht
        const minFPS = 30;
        const setExpensiveRenderMode = (on, logName) => {
            if (!on && this.msPerFrame < 1000 / minFPS) {
                return;
            }
            if (on && !STAGE.useComposer) {
                _.delay(() => STAGE.setDirty(), 200);
            }
            STAGE.useComposer = on;
            STAGE.toggleShadowEnabled(on);
        };
        setExpensiveRenderMode(true);
        STAGE.on("drag3dBegin", () => setExpensiveRenderMode(false, "drag.start"));
        STAGE.on("drag3dEnd", () => setExpensiveRenderMode(true, "drag.end"));
        STAGE.on("orbitControlsStart", () => setExpensiveRenderMode(false, "orbit.start"));
        STAGE.on("orbitControlsEnd", () => setExpensiveRenderMode(true, "orbit.end"));
        if (STAGE.composer) {
            APP.on("afterCompile", () => {
                const materialProduct = APP.findProduct(APP.arrangement.materials.corpus);
                const color = new THREE.Color(materialProduct.Kantenfarbe);
                const luminosity = color.getHSL().l;
                const lumSpan = Math.max(0.1, Math.min(1, (luminosity - 0.3) / (0.84 - 0.3)));
                if (STAGE.saoPass) {
                    STAGE.saoPass.params.saoIntensity = 0.001 * (1 - lumSpan) + 0.0003 * lumSpan;
                }
            });
        }
    }

    maybeShowAdminGui() {
        if (APP.settings.userRole == "admin" || APP.settings.localDevelopmentMode) {
            const gui = new dat.GUI();
            const params = STAGE.saoPass.params;
            gui.add(params, "output", {
                Beauty: THREE.SAOPass.OUTPUT.Beauty,
                "Beauty+SAO": THREE.SAOPass.OUTPUT.Default,
                SAO: THREE.SAOPass.OUTPUT.SAO,
                Depth: THREE.SAOPass.OUTPUT.Depth,
                Normal: THREE.SAOPass.OUTPUT.Normal,
            }).onChange((value) => (params.output = parseInt(value)));
            gui.add(params, "saoBias", -1, 1);
            gui.add(params, "saoIntensity", 0, 1);
            gui.add(params, "saoScale", 0, 10);
            gui.add(params, "saoKernelRadius", 1, 100);
            gui.add(params, "saoMinResolution", 0, 1);
            gui.add(params, "saoBlur");
            gui.add(params, "saoBlurRadius", 0, 200);
            gui.add(params, "saoBlurStdDev", 0.5, 150);
            gui.add(params, "saoBlurDepthCutoff", 0.0, 0.1);

            const taaParams = STAGE.taaRenderPass.datTaaParams;
            gui.add(taaParams, "TAAEnabled").onFinishChange(() => taaParams.update());
            gui.add(taaParams, "TAASampleLevel", {
                "Level 0: 1 Sample": 0,
                "Level 1: 2 Samples": 1,
                "Level 2: 4 Samples": 2,
                "Level 3: 8 Samples": 3,
                "Level 4: 16 Samples": 4,
                "Level 5: 32 Samples": 5,
            }).onFinishChange(() => taaParams.update());
        }
    }

    findProduct = Commons.cache((artikelnummer: ?string, failOnNull = false, schrankSize: ?Vector3) => {
        if (artikelnummer) {
            let product = this.productList.find((p) => p.Artikelnummer === artikelnummer);
            const articles = this.allArticles.filter( a => a.Artikelnummer === artikelnummer || a.Artikelnummer.startsWith(artikelnummer+"_"))
            
            if(schrankSize !== undefined) {
                const sortedByWidth = _.sortBy(articles, "abBreite");
                const matchingWidth = sortedByWidth.filter(p => p.abBreite >= schrankSize.x);
                product = matchingWidth[0];
            }

            if (failOnNull && product == null) {
                throw new Error("found no product artikelnummer=" + artikelnummer);
            }

            const materialPreise = APP.metadata.FrontenMaterialPreise.find(f => f.Material === product?.Artikelnummer);
            if(materialPreise) {
                product.qmPreis = materialPreise.qmPreis;
                product.qmPreisSchrank = materialPreise.qmPreisSchrank;
            }

            return product;
        }
        return null;
    });

    findProductVariancesMatching = Commons.cache((namePattern: ?string) => {
        if(namePattern) {
            return this.allArticles.filter( a => a.Artikelnummer == namePattern || a.Artikelnummer.startsWith(namePattern + "_"));
        }
        return [];
    });

    findProductsByType = Commons.cache((type: ?string) =>
        type ? this.productList.filter((p) => p.type === type).sort((a, b) => a.Anzeigereihenfolge - b.Anzeigereihenfolge) : null
    );

    findProductsByReiter = Commons.cache((reiter: ?string) =>
        reiter ? this.productList.filter((p) => p.reiter === reiter).sort((a, b) => a.Anzeigereihenfolge - b.Anzeigereihenfolge || a.Laenge - b.Laenge) : null
    );

    // findMaterialsByProdukt = Commons.cache((produktName: ?string) =>
    //     type ? this.productList.filter(p => p.type === 'Material' && ).sort((a, b) => a.Anzeigereihenfolge -
    // b.Anzeigereihenfolge) : null);

    getModel() {
        return APP.arrangement.selectedSchrank.modell;
    }

    mapProductsByType = Commons.cache((type: ?string, attr: ?string) => {
        const products = this.findProductsByType(type);
        const result = {};
        this.findProductsByType(type).forEach((p) => {
            const value = p[attr];
            let list = result[value];
            if (list) {
                list.push(p);
            } else {
                result[value] = [p];
            }
        });
        return result;
    });

    initUI() {
        new UIHandler();
        STAGE.appendRendererCanvasTo($(".threejsRenderer"));
    }

    setInitialCamera() {
        this.cameraAnimation();
    }

    getConfigurationType(configuration){
        if (!Commons.isEmpty(configuration.ordered_at)){
            return 'locked_config';
        }
        return super.getConfigurationType(configuration);
    }

    cameraAnimation(duration = 2000) {
        APP.arrangement.schraenke.forEach((schrank) => {
            schrank.object3d.visible = true;
        });
        const selectedSchrank = APP.arrangement.selectedSchrank;
        const target = selectedSchrank.getBox3World();
        const direction = selectedSchrank.worldNormale;
        const targetConfig = STAGE.getCameraConfigAsZoomTo(target, direction);

        STAGE.animateCameraTo(targetConfig, {
            duration: duration,
        });

        APP.arrangement.schraenke.forEach((schrank) => {
            if (schrank === APP.arrangement.selectedSchrank) return;
            if (schrank.worldNormale.equals(APP.arrangement.selectedSchrank.worldNormale.negate())) {
                schrank.object3d.visible = false;
            }
        });
    }

    maybeLoadFromLocalStorage() {
        try {
            const savedConfig = localStorage["schrankkonfigurator_cfg"];
            if (!this.settings.localDevelopmentMode && savedConfig !== undefined) {
                this.uiHandler.dialog({
                    title: I18N("restoreCfgHeader"), //'Speichern ist fehlgeschlagen!',
                    text: I18N("restoreCfgText"), //'Wir konnten Ihren Schrank nicht speichern.',
                    buttons: [
                        {
                            style: "default",
                            label: I18N("No"),
                            click: (input) => {
                                localStorage.removeItem("schrankkonfigurator_cfg");
                            },
                        },
                        {
                            style: "primary",
                            label: I18N("Yes"),
                            click: (input) => {
                                let newCfg = {};
                                $.extend(true, newCfg, this.configuration);
                                $.extend(true, newCfg, JSON.parse(savedConfig));
                                this.configuration = newCfg;
                                this.model.loadConfiguration();
                                localStorage.removeItem("schrankkonfigurator_cfg");
                            },
                        },
                    ],
                });
            }
        } catch (e) {}
    }

    saveToLocalStorage(configuration) {
        try {
            localStorage["schrankkonfigurator_cfg"] = JSON.stringify(configuration);
        } catch (e) {}
    }

    updateUI = _.debounce(() => this.updateUIForced(), 400);

    updateUIForced() {
        if (!this.uiHandler) {
            return;
        }
        this.uiHandler.updateFromArrangement();
    }

    getBoundingBox(artikelnummer: String) {
        Asserts.type(artikelnummer, "String");
        const product = this.findProduct(artikelnummer);
        if (product == null) {
            return new THREE.Box3();
        }
        const bb = boundingBoxes[product.objName];
        if (!bb) {
            return new THREE.Box3();
        }
        return new THREE.Box3().fromJSON(bb.box);
    }

    /**
     * Die folgende Methode wird nur auf der Console im Development aufgerufen!
     */
    createBoundingBoxesJson() {
        const boundingBoxesJson = {};
        const products = this.productList.filter((p) => !Commons.isEmpty(p.objName));
        let missing = [];
        UniversalLoader.cache = {};
        const downloadModelMetaData = () => {
            const jsonString = JSON.stringify(boundingBoxesJson, null, 2);
            const blob = new Blob([jsonString], { type: "application/json;charset=utf-8" });
            saveAs(blob, "boundingBoxes.json", "application/json");
            let message = "Die boundingBoxes.json wurde downgeloaded.";
            if (missing.length > 0) {
                message += "<br/><br/> Die folgenden Modelldateien fehlen:<br/><br/>" + Commons.unique(missing).join("<br/>");
            }
            Dialogs.showOk(message);
        };
        const loadNext = () => {
            if (products.length == 0) {
                downloadModelMetaData();
                return;
            }
            const product = products.pop();
            const url = APP.contentBaseUrl + product.objName;
            //console.log(url);
            UniversalLoader.loadModel(
                url,
                (obj) => {
                    //console.log(url);
                    obj.scale.set(100, 100, 100);
                    const box = Scenes.boundingBoxLocalMatrix(obj);
                    boundingBoxesJson[product.objName] = {
                        box: box.toJSON(),
                    };
                    loadNext();
                },
                () => {
                    missing.push(product.model);
                    loadNext();
                }
            );
        };
        loadNext();
    }

    nextId() {
        return this.idCounter++;
    }

    getDekorTypen = Commons.cache(() => {
        return _.orderBy(APP.metadata.Dekortyp, "Anzeigereihenfolge");
    });

    getGriffGruppen = Commons.cache(() => {
        return _.orderBy(APP.metadata.Produktgruppen, "Anzeigereihenfolge");
    });
    getUsedGriffGruppen = Commons.cache(() => {
        const usedGroups = _.uniq(APP.findProductsByReiter("Griffe").map(p => p.Produktgruppe));
        const groups = {};
        _.forEach(APP.metadata.Produktgruppen, (value, key) => {
            if(usedGroups.includes(key)) {
                groups[key] = value;
            }
        });
        return _.orderBy(groups, "Anzeigereihenfolge");
    });
    getGriffeForGruppe = Commons.cache( name => {
        const gruppen = _.groupBy(APP.findProductsByReiter("Griffe"), "Produktgruppe");
        return gruppen[name] || [];
    });

    createDekor2DefaultMaterial() {
        const map = {};
        this.getDekorTypen().forEach((x) => (map[x.Name] = x.DefaultMaterial));
        return map;
    }

    getMaterialKeysForDekorTyp = Commons.cache((dekortypName) => {
        Asserts.type(dekortypName, "String");
        const materials = _.orderBy(
            APP.metadata.MaterialJeDekortyp.filter((x) => x.Dekortyp == dekortypName),
            "Anzeigereihenfolge"
        ).map((x) => x.Material);
        const dekortyp = APP.metadata.Dekortyp.find((d) => d.Name == dekortypName);
        const defaultMaterial = dekortyp.DefaultMaterial;
        if (!materials.includes(defaultMaterial)) {
            materials.push(defaultMaterial);
        }
        return materials;
    });

    getMaterialsForDekorTyp = Commons.cache((dekortypName) => {
        return APP.getMaterialKeysForDekorTyp(dekortypName).map((x) => APP.findProduct(x));
    });

    healMaterials(materials, allowNulls = false) {
        this.getDekorTypen().forEach((x) => {
            if (materials[x.Name] === undefined) {
                materials[x.Name] = null;
            }
        });
        _.keys(materials).forEach((key) => {
            const dekortyp = APP.metadata.Dekortyp.find((x) => x.Name == key);
            if (dekortyp == null) {
                delete materials[key];
                return;
            }
            const value = materials[key];
            if (allowNulls && value == null) {
                return;
            }
            const allowedMaterials = APP.getMaterialKeysForDekorTyp(key == 'sockel' ? 'front' : key);
            if (!allowedMaterials.includes(value)) {
                materials[key] = dekortyp.DefaultMaterial;
            }
        });
    }

    getDekortypJeProdukt = Commons.cache((modell, productArtikelnummer: String) => {
        Asserts.type(productArtikelnummer, "?String");
        return APP.metadata.DekortypJeProdukt.find((x) => x.Modell == modell && x.Produkt == productArtikelnummer);
    });

    getDekortypForVsData(vsData): String {
        const modell = APP.arrangement.selectedSchrank.modell.Name;
        const dekortypJeProdukt = APP.getDekortypJeProdukt(modell, vsData.product?.Artikelnummer);
        const standard = APP.getDekortypJeProdukt("Standard", vsData.product?.Artikelnummer);
        let dekortyp = dekortypJeProdukt == null ? standard?.Dekortyp : dekortypJeProdukt.Dekortyp;

        // TODO: Das ist dirty. Wieso hat ein Interieur beim Dragvorgang noch kein product?!
        if (!dekortyp) dekortyp = APP.metadata.Dekortyp[0].Name;
        Asserts.type(dekortyp, "String");
        return dekortyp;
    }

    getMaterialsForVsData(vsData) {
        const dekortyp = this.getDekortypForVsData(vsData);
        return this.getMaterialsForDekorTyp(dekortyp);
    }

    getMaterialForVsData(vsData) {
        const dekortyp = this.getDekortypForVsData(vsData);
        let x = vsData;
        while (x != null) {
            if (x.materials != null) {
                const material = x.materials[dekortyp];
                if (material != null) {
                    return material;
                }
            }
            x = x.parent;
        }
        // console.log('getMaterialForVsData',Commons.typeName(vsData),null);
        return null;
    }

    setMaterialForVsData(vsData, material: String) {
        Asserts.type(material, "String");
        const dekortyp = this.getDekortypForVsData(vsData);
        let x = vsData;
        while (x != null) {
            if (x.materials != null) {
                this.deleteMaterialsRecursive(x, dekortyp);
                x.materials[dekortyp] = material;
                break;
            }
            x = x.parent;
        }
        APP.model.setDirty();
    }

    deleteMaterialsRecursive(vsData, dekortypName) {
        Asserts.type(dekortypName, "String");
        vsData.iterate((c) => {
            if (c.materials && c.materials[dekortypName] != null) {
                c.materials[dekortypName] = null;
            }
        });
    }

    save(okCallback, failCallback, sendMail = false, sendMailOnSaveOnly = false, sendMailOnSaveAddress = "") {
        const configuration = APP.configuration;
        configuration.Json = APP.arrangement.toJSON();
        let modelle = "";
        APP.arrangement.schraenke.forEach((schrank, index) => {
            modelle += schrank.modell.Name;
            if (APP.arrangement.schraenke.length > 1 && index !== APP.arrangement.schraenke.length - 1) {
                modelle += ";";
            }
        });
        const getAuftragsstatus = () => {
            if(sendMail) {
                return configuration.Json.kunde.DirektBeiHaendler ? "Bei Hersteller bestellt" : "Bei Händler bestellt";
            } else {
                return "Entwurf";
            }
        }
        configuration.Modelle = modelle;
        configuration.Auftragsstatus = getAuftragsstatus();
        configuration.Konfigurator = "Schrank"

        const isAdmin = APP.settings.userRole == "admin";
        const isInspiration = configuration.Inspiration;
        let method = "create";

        configuration.Preis = configuration.Json.preis;
        if (this.haendler) {
            configuration.HaendlerId = this.haendler.id;
        }

        if (this.toInspiration && isAdmin) {
            method = "create";
            configuration.Inspiration = true;
            delete configuration.id;
        } else {
            if (isInspiration) {
                method = "create";
                configuration.Inspiration = false;
                configuration.Code = null;
                delete configuration.id;
            } else {
                method = configuration.id ? "update" : "create";
            }
        }

        if(sendMailOnSaveOnly) {
            configuration.Json.mailOnSave = "true";
            configuration.Json.savedEmail = sendMailOnSaveAddress;
        }
        
        APP.wkfgBackendApi
            .saveMetadata("Konfiguration", method, configuration)
            .then((data) => {
                uiActions._makeImages(data, () => {
                    const urlParams = new URLSearchParams(window.location.search);
                    urlParams.set("Code", data.Code);
                    APP.configuration.Code = data.Code;
                    APP.configuration.id = data.id;

                    console.log(APP.configuration)
                    if (history.pushState) {
                        var newurl =
                        window.location.protocol +
                        "//" +
                        window.location.host +
                        window.location.pathname +
                        "?" +
                        urlParams.toString();
                        window.history.pushState({path: newurl}, "", newurl);
                    }
                    if(sendMail || sendMailOnSaveOnly) APP.wkfgBackendApi.sendKonfigurationMail();
                    okCallback(data.Json);
                });
            })
            .catch(failCallback);
    }

    getPdfUrl(configuration) {
        return APP.wkfgBackendApi.getPdfUrl(configuration.Code, false);
    }

    uploadImage(id, name, data, cb, failCB) {
        const imgData = {
            fileName: name,
            blob: data,
        };
        APP.wkfgBackendApi.uploadContent(`Konfiguration/${id}`, imgData).then(cb).catch(failCB);
    }

    uploadGlb(id, data, cb, failCB) {
        const upload = {
            fileName: data.blobName,
            blob: data.blob,
        };
        APP.wkfgBackendApi.uploadContent(`Konfiguration/${id}`, upload).then(cb).catch(failCB);
    }

    uploadRenderData(id, data, cb, failCB) {
        const upload = {
            fileName: data.name,
            blob: new Blob([JSON.stringify([data.width, data.height, data.depth])], { type: "application/json" }),
        };
        APP.wkfgBackendApi.uploadContent(`Konfiguration/${id}`, upload).then(cb).catch(failCB);
    }

    saveImages(cfg, cb, failCB) {
        const uploads = [
            { fileName: cfg.screenshotFile, blob: cfg.screenshotData },
            { fileName: cfg.screenshot2File, blob: cfg.screenshot2Data },
            { fileName: cfg.sketchFile, blob: cfg.sketchData },
        ];
        if (cfg.screenshot3File) {
            uploads.push(
                { fileName: cfg.screenshot3File, blob: cfg.screenshot3Data },
                { fileName: cfg.screenshot4File, blob: cfg.screenshot4Data },
                { fileName: cfg.sketch2File, blob: cfg.sketch2Data }
            );
        }
        APP.wkfgBackendApi.uploadContent(`Konfiguration/${cfg.id}`, uploads).then(cb).catch(failCB);
    }
}

const currentUrl = new UrlFluid(location.href + "");
const url = new UrlFluid(SETTINGS.apiBackendUrl);
url.keyValues = url.keyValues.concat(currentUrl.keyValues);
url.param("api", "1");

const urlParams = new URLSearchParams(window.location.search);

$.getJSON(url.toString())
    .done((data) => {
        //TODO: Was ist n das? :)
        // console.log(data);
        // data.Konfiguration.Json.Modell.edit = false;
        // data.Konfiguration.Json.Modell.admin = false;
        // data.Konfiguration.Json.Modell.shop = "default";
        // data.Konfiguration.Json.Modell.api = null;
        // data.settings.redirectAfterSave = Urls.urlParam("redirectAfterSave");
        const mountpoint = $("#cfg");
        new Schrankplaner(mountpoint, data);
    })
    .fail((jqXHR, textStatus, errorThrown) => {
        console.error("error in APP.load", jqXHR, textStatus, errorThrown);
        const mountpoint = $("#cfg");
        const text = (jqXHR.responseJSON && jqXHR.responseJSON.error && jqXHR.responseJSON && jqXHR.responseJSON.error.message) || errorThrown;
    });

window.$ = $;
window.jQuery = jQuery;

$("body").trigger("cfg.ready");
